import { Component, Input, OnInit } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { UserService } from '../../../services/user.service';
import { ILeftSideMenuLabel, IUser } from '../../../models';
import { LanguageTranslationService } from '../../../services/language-translation.service';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
})
export class MenuComponent implements OnInit {
  @Input() childMessage: string;

  greeting = [{ eng: 'Hello' }, { fre: 'Bonjour' }];

  greetingLanguageLabel: string;
  isV6Admin: boolean;
  isMarketingAdmin: boolean;
  hasAccessToAccountSummary: boolean;
  hasAccessToInvInquiry: boolean;
  canManageExtUser: any;
  canMakePayment: boolean = false;
  isEXTUser: any;
  isIntUser: any;
  canManageAddress: any;
  isKawneerAdmin: boolean;
  hasAccessToAdmin: boolean;
  canRaiseClaim: boolean;
  canManageClaim: boolean;
  //#Region Product Sample Pulfillment
  isSampleProductAdmin: boolean;  
  //#End Region
  isDiscStoreItemAdmin: boolean;
  isDiscStoreOrderAdmin: boolean;

  constructor(private userService: UserService, private languageTranslationService: LanguageTranslationService) { }

  items: MenuItem[];

  isCollapsed = true;
  home: string;
  orderManagement: string;
  buildAndBuy: string;
  selfServiceUtilities: string;
  invoiceInquiry: string;
  manageQuotes: string;
  orderInquiry: string;
  lienRelease: string;
  creditReference: string;
  generateWarranty: string;
  sampleRequest: string;
  submittalPackage: string;
  thermalCalculator: string;
  literature: string;
  priceCatalog: string;
  installationInstructions: string;
  orderForms: string;
  correctiveFieldRepair: string;
  estimatingAndTakeoffGuides: string;
  certifications: string;
  videosAndTraining: string;
  installationAndCare: string;
  cleaningAluminumFinishes: string;
  installationVideoCurtainwall: string;
  installationVideoStorefront: string;
  learn: string;
  tips: string;
  addressManagement: string;
  advancedSearch: string;
  buildAndBuyLowercase: string;
  kawneerDirectOnDemand: string;
  orderingA1DoorFrame: string;
  orderingGlassVent: string;
  quotes: string;
  addingCartItemsToQuote: string;
  createAQuote: string;
  placeOrderWithQuote: string;
  requestAQuote: string;
  updateExpiredQuotes: string;
  training: string;
  customerSpecificSchool: string;
  mechanicsSchool: string;
  modulesSchool: string;
  partnerPakTraining: string;
  preInstallationSystemReview: string;
  howToLbl: string;
  newsLbl: string;
  windowPricingToolLbl: string;
  //#region roles variable declaration
  isSuperAdmin: boolean = false;
  rolesBuildpackAccess: boolean;
  marketingAdminAccess: boolean = false;
  kawneerAdminAccess: boolean = false;
  isInternalUser: boolean = false; //if role is INTuser then hide admin module
  isEXTuserInvoice: boolean = false;
  userAdminAccess: boolean = false;
  //endregion
  protected adminMenu = {
    lebel: "Admin",
    buildPakAdmin: {
      lebel: "BuildPAK Admin",
      manageAttribute: "Manage Attribute"
    },
    kawneerAdmin: {
      lebel: "Kawneer Admin",
      languageTranslation: "Language Translation",
      itemAdministration: "Item Administration",
      errordashboard: "Error Dashboard"
    },
    marketingAdmin: {
      lebel: "Marketing Admin",
      submittalPackageAdmin: "Submittal Package Admin",
      sampleRequestAdmin: "Sample Request Admin",
      broadcastMessageAdmin: "Broadcast Message Admin",
      homescreenBannerAdmin: "HomeScreen Banner Admin",
      imageAdmin: "Image Admin",
      promoCodeAdmin: "Promo Code",
      outageScheduleAdmin: "Outage Schedule",
      customerSpecificSchoolAdmin: "Customer Specific School Admin",
      mechanicsSchoolAdmin: "Mechanics School Admin",
      modulesSchoolAdmin: "Modules School Admin",
      partnerPakTrainingAdmin: "Partner Pak Training Admin",
      preInstallationSystemReviewAdmin: "Pre Installation System Review Admin",
      surveyAdmin: "Survey Admin",
      newsAdmin: "News Admin",
    },
    userAdministration: {
      label: "User Administration",
      userAdmin: "User Admin"
    },
    claimAdministration: {
      label: "Freight Claim",
      reviewOpenClaimAdmin: "Review Open Claims",
      claimHistoryAdmin: "Freight Claim History"
    },
    //#Region Product Sample Pulfillment
    productSampleAdminstration: {
      label: "Product Sample Admin",
      sampleAdmin: "Sample Request Admin",
      orderHistory: "Sample Request Order History",
      inventoryReport: "Sample Request Inventory/Usage Report"
    },
    discStoreAdministration: {
      label: "Overstock Store Admin",
      reviewOpenOrders: "Review Open Orders",
      orderHistory: "Order History"
    },

  }

  toggleLogin() {
    this.isCollapsed = !this.isCollapsed;
  }


  menuLblTxt: ILeftSideMenuLabel = {
    home: "",
    admin: "",
    orderManagement: "",
    invoiceInquiry: "",
    manageQuotes: "",
    orderInquiry: "",
    buildAndBuyLowercase: "",
    selfServiceUtilities: "",
    creditReference: "",
    generateWarranty: "",
    sampleRequest: "",
    submittalPackage: "",
    lienRelease: "",
    thermalCalculator: "",
    windowPricingToolLbl: "",
    literature: "",
    priceCatalog: "",
    installationAndCare: "",
    installationInstructions: "",
    installationVideoCurtainwall: "",
    cleaningAluminumFinishes: "",
    installationVideoStorefront: "",
    orderForms: "",
    correctiveFieldRepair: "",
    estimatingAndTakeoffGuides: "",
    certifications: "",
    videoTrainingLbl: "",
    training: "",
    customerSpecificSchool: "",
    mechanicsSchool: "",
    modulesSchool: "",
    partnerPakTraining: "",
    preInstallationSystemReview: "",
    newsLbl: "",
  }
  async getText() {
    // await this.cachingService.getControlText().then(async () => {

    this.home = 'Home';
    this.orderManagement = 'Order Management';
    this.buildAndBuy = 'Build And Buy';
    this.selfServiceUtilities = 'Self Service Utilities';
    this.invoiceInquiry = 'Invoice Inquiry';
    this.manageQuotes = 'Manage Quotes';
    this.orderInquiry = 'Order Inquiry';
    this.lienRelease = 'Lien Release';
    this.creditReference = 'Credit Reference';
    this.generateWarranty = 'Generate Warranty';
    this.sampleRequest = 'Sample Request';
    this.submittalPackage = 'Submittal Package';
    this.thermalCalculator = 'Thermal Calculator';
    this.literature = 'Literature';
    this.priceCatalog = 'Price Catalog';
    this.installationInstructions = 'Installation Instructions';
    this.orderForms = 'Order Forms';
    this.correctiveFieldRepair = 'Corrective Field Repair';
    this.estimatingAndTakeoffGuides = 'Estimating And Take off Guides';
    this.certifications = 'Certifications';
    this.videosAndTraining = 'Videos And Training';
    this.installationAndCare = 'Installation And Care';
    this.cleaningAluminumFinishes = 'Cleaning Aluminum Finishes';
    this.installationVideoCurtainwall = 'Installation Video Curtain wall';
    this.installationVideoStorefront = 'Installation Video Store front';

    this.tips = 'tips';
    this.addressManagement = 'addressManagement';
    this.advancedSearch = 'advancedSearch';
    this.buildAndBuyLowercase = 'buildAndBuyLowercase';
    this.kawneerDirectOnDemand = 'kawneerDirectOnDemand';
    this.orderingA1DoorFrame = 'orderingA1DoorFrame';
    this.orderingGlassVent = 'orderingGlassVent';
    this.quotes = 'quotes';
    this.addingCartItemsToQuote = 'addingCartItemsToQuote';
    this.createAQuote = 'createAQuote';
    this.placeOrderWithQuote = 'placeOrderWithQuote';
    this.requestAQuote = 'requestAQuote';
    this.updateExpiredQuotes = 'updateExpiredQuotes';
    this.training = 'Training';
    this.customerSpecificSchool = 'Customer Specific School';
    this.mechanicsSchool = 'Mechanics School';
    this.modulesSchool = 'Modules School';
    this.partnerPakTraining = 'PartnerPak Training';
    this.preInstallationSystemReview = 'Pre Installation System Review';
    this.newsLbl = 'News';
    this.howToLbl = 'HOW TO';
    this.windowPricingToolLbl = 'Window Pricing Tool';
    // });
  }

  //calling the user service for roles base validation
  protected get loggedInUser(): IUser {
    return this.userService.readUserObject;
  }
  async ngOnInit() {
    this.loadLanguageTranslationData();
    this.greetingLanguageLabel = this.greeting[0].eng;
    await this.getText();
    this.initAccess();
    this.setMenu();


  } // end Menu.Component.ts
  initAccess() {
    this.isSuperAdmin = this.userService.isSuperAdmin();
    this.isV6Admin = this.userService.isV6Admin();
    this.isMarketingAdmin = this.userService.isMarketingAdmin();
    this.isKawneerAdmin = this.userService.isKawneerAdmin();
    this.hasAccessToAccountSummary = this.userService.hasAccessToAccountSummary();
    this.hasAccessToInvInquiry = this.userService.hasAccessToInvoiceInquiry();
    this.canManageExtUser = this.userService.canManageExtUser();
    this.isEXTUser = this.userService.isEXTUser();
    this.isIntUser = this.userService.isIntUser();
    this.canManageAddress = this.userService.canManageAddress();
    this.hasAccessToAdmin = this.userService.hasAccessToAdminMenu();
    this.canManageExtUser = this.userService.canManageExtUser();
    this.canMakePayment = this.userService.hasAccessToMakeInvoicePayment();
    this.canRaiseClaim = this.userService.canSubmitFreightClaim();
    this.canManageClaim = this.userService.canMangeFreightClaim();
    //#Region Product Sample Pulfillment
    this.isSampleProductAdmin = this.userService.isSampleProductAdmin();
    //#End region
    this.isDiscStoreItemAdmin=this.userService.hasAccessToClearanceStoreItemMgmt();
    this.isDiscStoreOrderAdmin=this.userService.hasAccessToClearanceStoreOrderMgmt();
  }
  setMenu() {
    this.items = [
      {
        label: this.menuLblTxt.home ? this.menuLblTxt.home : this.home,
        routerLink: 'home',
        command: (event: Event) => (this.isCollapsed = true),
      },     
      {
        label: this.menuLblTxt.admin ? this.menuLblTxt.admin : this.adminMenu.lebel,
        icon: 'k-icon k-i-arrow-60-right',
        visible: (this.hasAccessToAdmin),
        items: [
          { label: '' },
          { label: '' },
          {
            label: this.adminMenu.buildPakAdmin.lebel,
            icon: 'k-icon k-i-arrow-60-right',
            items: [
              { label: '' },
              { label: '' },
              { label: '' },
              {
                label: this.adminMenu.buildPakAdmin.manageAttribute,
                routerLink: ['manageAttribute'],
                command: (event: Event) => (this.isCollapsed = true),
              },
              {
                label: "Manage Product",
                routerLink: ['manageProduct'],
                command: (event: Event) => (this.isCollapsed = true),
              },
              {
                label: "Manage Macro",
                routerLink: ['manageMacro'],
                command: (event: Event) => (this.isCollapsed = true),
              },
              //{
              //  label: "Product Config Shortcut",
              //  routerLink: ['configProduct'],
              //  command: (event: Event) => (this.isCollapsed = true),
              //},
              //{
              //  label: "Create Configuration",
              //  routerLink: ['configProduct/createConfiguration'],
              //  command: (event: Event) => (this.isCollapsed = true),
              //},
              {
                label: "Manage Translation",
                routerLink: ['manageTranslation'],
                command: (event: Event) => (this.isCollapsed = true),
              },
              {
                label: "Manage Product Hierarchy",
                routerLink: ['product-setup'],
                command: (event: Event) => (this.isCollapsed = true),
              }
            ],
            visible: this.isV6Admin
          },
          {
            label: this.adminMenu.kawneerAdmin.lebel,
            icon: 'k-icon k-i-arrow-60-right',
            items: [
              { label: '' },
              { label: '' },
              { label: '' },
              {
                label: this.adminMenu.kawneerAdmin.languageTranslation,
                routerLink: ['languageTranslation'],
                command: (event: Event) => (this.isCollapsed = true),
              },
              {
                label: this.adminMenu.kawneerAdmin.itemAdministration,
                routerLink: ['itemAdministration'],
                command: (event: Event) => (this.isCollapsed = true),
              },
              {
                label: this.adminMenu.kawneerAdmin.errordashboard,
                routerLink: ['error-dashboard'],
                command: (event: Event) => (this.isCollapsed = true),
              },
            ],
            visible: this.isKawneerAdmin
          },


          {
            label: this.adminMenu.marketingAdmin.lebel,
            icon: 'k-icon k-i-arrow-60-right',
            items: [
              { label: '' },
              { label: '' },
              { label: '' },
              {
                label: this.adminMenu.marketingAdmin.submittalPackageAdmin,
                routerLink: ['submittal-package-admin'],
                command: (event: Event) => (this.isCollapsed = true),
              },
              //{
              //  label: this.adminMenu.marketingAdmin.sampleRequestAdmin,
              //  routerLink: ['sample-request-admin'],
              //  command: (event: Event) => (this.isCollapsed = true),
              //},
              {
                label: this.adminMenu.marketingAdmin.broadcastMessageAdmin,
                routerLink: ['broadcast-message-admin'],
                command: (event: Event) => (this.isCollapsed = true),
              },
              {
                label: this.adminMenu.marketingAdmin.homescreenBannerAdmin,
                routerLink: ['homescreen-banner-admin'],
                command: (event: Event) => (this.isCollapsed = true),
              },
              {
                label: this.adminMenu.marketingAdmin.imageAdmin,
                routerLink: ['images-admin'],
                command: (event: Event) => (this.isCollapsed = true),
              },
              {
                label: this.adminMenu.marketingAdmin.promoCodeAdmin,
                routerLink: ['promo-code'],
                command: (event: Event) => (this.isCollapsed = true),
              },
              {
                label: this.adminMenu.marketingAdmin.outageScheduleAdmin,
                routerLink: ['outage-schedule'],
                command: (event: Event) => (this.isCollapsed = true),
              },
              {
                label: this.adminMenu.marketingAdmin.customerSpecificSchoolAdmin,
                routerLink: ['customer-specific-school-admin'],
                command: (event: Event) => (this.isCollapsed = true),
              },
              {
                label: this.adminMenu.marketingAdmin.mechanicsSchoolAdmin,
                routerLink: ['mechanics-school-admin'],
                command: (event: Event) => (this.isCollapsed = true),
              },
              {
                label: this.adminMenu.marketingAdmin.modulesSchoolAdmin,
                routerLink: ['modules-school-admin'],
                command: (event: Event) => (this.isCollapsed = true),
              },
              {
                label: this.adminMenu.marketingAdmin.partnerPakTrainingAdmin,
                routerLink: ['partner-pak-training-admin'],
                command: (event: Event) => (this.isCollapsed = true),
              },
              {
                label: this.adminMenu.marketingAdmin.preInstallationSystemReviewAdmin,
                routerLink: ['pre-installation-system-review-admin'],
                command: (event: Event) => (this.isCollapsed = true),
              },
              {
                label: this.adminMenu.marketingAdmin.surveyAdmin,
                routerLink: ['survey-admin'],
                command: (event: Event) => (this.isCollapsed = true),
              },
              {
                label: this.adminMenu.marketingAdmin.newsAdmin,
                routerLink: ['news-admin'],
                command: (event: Event) => (this.isCollapsed = true),
              },

            ],
            visible: this.isMarketingAdmin
          },

          {
            label: this.adminMenu.userAdministration.label,
            icon: 'k-icon k-i-arrow-60-right',
            items: [
              { label: '' },
              { label: '' },
              { label: '' },
              {
                label: this.adminMenu.userAdministration.userAdmin,
                routerLink: ['user-admin'],
                command: (event: Event) => (this.isCollapsed = true),
              },
            ],
            visible: this.canManageExtUser
          },
          {
            label: 'Freight Claim',
            icon: 'k-icon k-i-arrow-60-right',
            items: [
              { label: '' },
              { label: '' },
              { label: '' },
              {
                label: 'Review Open Freight Claims',
                routerLink: ['review-open-claims'],
                command: (event: Event) => (this.isCollapsed = true),
                visible: this.canManageClaim
              },
              {
                label: 'Freight Claim History',
                routerLink: ['view-claim-history'],
                command: (event: Event) => (this.isCollapsed = true),
                visible: this.canManageClaim
              },
            ],
            visible: this.canManageClaim
          },
          //#Region Product Sample Pulfillment
          {
            label: this.adminMenu.productSampleAdminstration.label,
            icon: 'k-icon k-i-arrow-60-right',
            items: [
              { label: '' },
              { label: '' },
              { label: '' },
              {
                label: this.adminMenu.productSampleAdminstration.sampleAdmin,
                routerLink: ['sample-request-admin'],
                command: (event: Event) => (this.isCollapsed = true),
                visible: this.isSampleProductAdmin
              }              
            ],
            visible: this.isSampleProductAdmin
          },
          //#EndRegion
          {
            label: 'Overstock Store Admin',
            icon: 'k-icon k-i-arrow-60-right',
            items: [
              { label: '' },
              { label: '' },
              { label: '' },
              {
                label: 'Review Open Orders',
                routerLink: ['review-open-clearance-store-orders'],
                command: (event: Event) => (this.isCollapsed = true),
                visible: this.isDiscStoreOrderAdmin
              },
              {
                label: 'Order History',
                routerLink: ['view-clearance-store-order-history'],
                command: (event: Event) => (this.isCollapsed = true),
                visible: this.isDiscStoreOrderAdmin
              },
              {
                label: 'Manage Overstock Store',
                routerLink: ['manage-clearance-store'],
                command: (event: Event) => (this.isCollapsed = true),
                visible: this.isDiscStoreItemAdmin
              },
            ],
            visible: (this.isDiscStoreOrderAdmin || this.isDiscStoreItemAdmin)
          },

        ],
      },
      {
        label: this.menuLblTxt.orderManagement ? this.menuLblTxt.orderManagement : this.orderManagement,
        icon: 'k-icon k-i-arrow-60-right',

        items: [
          { label: '' },
          { label: '' },
          {
            label: this.menuLblTxt.invoiceInquiry ? this.menuLblTxt.invoiceInquiry : this.invoiceInquiry,
            routerLink: ['invoice-inquiry'],
            command: (event: Event) => (this.isCollapsed = true),
            visible: this.hasAccessToInvInquiry,   //hiding and showing invoice inquiry menu based on access
          },
          {
            label: this.menuLblTxt.manageQuotes ? this.menuLblTxt.manageQuotes : this.manageQuotes,
            routerLink: ['manage-quote'],
            command: (event: Event) => (this.isCollapsed = true),
          },
          {
            label: this.menuLblTxt.orderInquiry ? this.menuLblTxt.orderInquiry : this.orderInquiry,
            routerLink: ['order-inquiry'],
            command: (event: Event) => (this.isCollapsed = true),
          },

        ],
      },
      {
        label: this.menuLblTxt.buildAndBuyLowercase ? this.menuLblTxt.buildAndBuyLowercase : this.buildAndBuy,
        routerLink: ['build-and-buy'],
        command: (event: Event) => (this.isCollapsed = true),
      },
      {
        label: this.menuLblTxt.selfServiceUtilities ? this.menuLblTxt.selfServiceUtilities : this.selfServiceUtilities,
        icon: 'k-icon k-i-arrow-60-right',
        items: [
          { label: '' },
          { label: '' },
          {
            label: this.menuLblTxt.creditReference ? this.menuLblTxt.creditReference : this.creditReference,
            routerLink: ['self-service/credit-reference'],
            command: (event: Event) => (this.isCollapsed = true),
          },
          {
            label: this.menuLblTxt.generateWarranty ? this.menuLblTxt.generateWarranty : this.generateWarranty,
            routerLink: ['self-service/generate-warranty'],
            command: (event: Event) => (this.isCollapsed = true),
          },
          {
            label: this.menuLblTxt.sampleRequest ? this.menuLblTxt.sampleRequest : this.sampleRequest,
            routerLink: ['self-service/sample-request'],
            command: (event: Event) => (this.isCollapsed = true),
          },
          {
            label: this.menuLblTxt.submittalPackage ? this.menuLblTxt.submittalPackage : this.submittalPackage,
            routerLink: ['self-service/submittal-package'],
            command: (event: Event) => (this.isCollapsed = true),
          },
          {
            label: this.menuLblTxt.lienRelease ? this.menuLblTxt.lienRelease : this.lienRelease,
            routerLink: ['self-service/lien-release'],
            command: (event: Event) => (this.isCollapsed = true),
          },
          {
            label: this.menuLblTxt.thermalCalculator ? this.menuLblTxt.thermalCalculator : this.thermalCalculator,
            routerLink: ['self-service/thermal-calculator'],
            command: (event: Event) => (this.isCollapsed = true),
          },
          {
            label: this.menuLblTxt.windowPricingToolLbl ? this.menuLblTxt.windowPricingToolLbl : this.windowPricingToolLbl,
            routerLink: ['self-service/window-pricing'],
            command: (event: Event) => (this.isCollapsed = true),
          },
          {
            label: 'Account Payments',
            routerLink: ['invoice-inquiry/payment/review'],
            command: (event: Event) => (this.isCollapsed = true),
            visible: this.canMakePayment,
          },
          {
            label: 'Freight Claim',//this.menuLblTxt.freightClaimLbl ? this.menuLblTxt.freightClaimLbl : this.freightClaimLbl,
            icon: 'k-icon k-i-arrow-60-right',
            visible: this.canRaiseClaim,
            items: [
              { label: '' },
              { label: '' },
              { label: '' },
              {
                label: 'Submit Freight Claim',
                routerLink: ['self-service/order-selection'],
                command: (event: Event) => (this.isCollapsed = true),
                visible: this.canRaiseClaim,
              },
              {
                label: 'Freight Claim History',
                routerLink: ['self-service/claim-history'],
                command: (event: Event) => (this.isCollapsed = true),
                visible: this.canRaiseClaim,
              }
            ]
          },
        ],
      },
      {
        label: this.menuLblTxt.literature ? this.menuLblTxt.literature : this.literature,
        icon: 'k-icon k-i-arrow-60-right',
        items: [
          { label: '' },
          { label: '' },
          {
            label: this.menuLblTxt.newsLbl ? this.menuLblTxt.newsLbl : this.newsLbl,
            routerLink: ['literature/news/literature-pages/18'],
            command: (event: Event) => (this.isCollapsed = true),
          },
          {
            label: this.menuLblTxt.priceCatalog ? this.menuLblTxt.priceCatalog : this.priceCatalog,
            routerLink: ['literature/price-catalog/literature-pages/3'],
            command: (event: Event) => (this.isCollapsed = true),
          },
          {
            label: this.menuLblTxt.installationAndCare ? this.menuLblTxt.installationAndCare : this.installationAndCare,
            icon: 'k-icon k-i-arrow-60-right',
            items: [
              { label: '' },
              { label: '' },
              { label: '' },
              {
                label: this.menuLblTxt.installationInstructions ? this.menuLblTxt.installationInstructions : this.installationInstructions,
                routerLink: ['literature/installation-instructions/literature-pages/1'],
                command: (event: Event) => (this.isCollapsed = true),
              },
              {
                label: this.menuLblTxt.cleaningAluminumFinishes ? this.menuLblTxt.cleaningAluminumFinishes : this.cleaningAluminumFinishes,
                routerLink: ['literature/cleaninig-aluminium/details-screen/22/Cleaninig-aluminium'],
                command: (event: Event) => (this.isCollapsed = true),
              },
              {
                label: this.menuLblTxt.installationVideoCurtainwall ? this.menuLblTxt.installationVideoCurtainwall : this.installationVideoCurtainwall,
                routerLink: ['literature/installation-video-curtain-wall/details-screen/20/Installation-video-curtain-wall'],
                command: (event: Event) => (this.isCollapsed = true),
              },
              {
                label: this.menuLblTxt.installationVideoStorefront ? this.menuLblTxt.installationVideoStorefront : this.installationVideoStorefront,
                routerLink: ['literature/installation-video-store-front/details-screen/19/Installation-video-store-front'],
                command: (event: Event) => (this.isCollapsed = true),
              },
            ],
          },
          {
            label: this.menuLblTxt.orderForms ? this.menuLblTxt.orderForms : this.orderForms,
            routerLink: ['literature/order-forms/details-screen/23/Order-forms'],
            command: (event: Event) => (this.isCollapsed = true),
          },
          {
            label: this.menuLblTxt.correctiveFieldRepair ? this.menuLblTxt.correctiveFieldRepair : this.correctiveFieldRepair,
            routerLink: ['literature/corrective-field-repair/details-screen/37/Corrective-field-repair'],
            command: (event: Event) => (this.isCollapsed = true),
          },
          {
            label: this.menuLblTxt.estimatingAndTakeoffGuides ? this.menuLblTxt.estimatingAndTakeoffGuides : this.estimatingAndTakeoffGuides,
            routerLink: ['literature/estimating-takeoff-guide/literature-pages/2'],
            command: (event: Event) => (this.isCollapsed = true),
          },
          {
            label: this.menuLblTxt.certifications ? this.menuLblTxt.certifications : this.certifications,
            routerLink: ['literature/certifications/literature-pages/17'],
            command: (event: Event) => (this.isCollapsed = true),
          },
        ],
      },
      {
        label: this.menuLblTxt.videoTrainingLbl ? this.menuLblTxt.videoTrainingLbl : this.videosAndTraining,
        icon: 'k-icon k-i-arrow-60-right',
        items: [
          { label: '' },
          { label: '' },
          {
            label: this.menuLblTxt.training ? this.menuLblTxt.training : this.training,
            icon: 'k-icon k-i-arrow-60-right',
            items: [
              { label: '' },
              { label: '' },
              { label: '' },
              {
                label: this.menuLblTxt.customerSpecificSchool ? this.menuLblTxt.customerSpecificSchool : this.customerSpecificSchool,
                routerLink: ['training/customer-specific-school'],
                command: (event: Event) => (this.isCollapsed = true),
              },
              {
                label: this.menuLblTxt.mechanicsSchool ? this.menuLblTxt.mechanicsSchool : this.mechanicsSchool,
                routerLink: ['training/mechanics-school'],
                command: (event: Event) => (this.isCollapsed = true),
              },
              {
                label: this.menuLblTxt.modulesSchool ? this.menuLblTxt.modulesSchool : this.modulesSchool,
                routerLink: ['training/modules-school'],
                command: (event: Event) => (this.isCollapsed = true),
              },
              {
                label: this.menuLblTxt.partnerPakTraining ? this.menuLblTxt.partnerPakTraining : this.partnerPakTraining,
                routerLink: ['training/partner-pak-training'],
                command: (event: Event) => (this.isCollapsed = true),
              },
              {
                label: this.menuLblTxt.preInstallationSystemReview ? this.menuLblTxt.preInstallationSystemReview : this.preInstallationSystemReview,
                routerLink: ['training/pre-installation-system-review'],
                command: (event: Event) => (this.isCollapsed = true),
              },
            ],
          },
        ],
      },
      {
        label: this.howToLbl,
        command: (event: Event) => {
          this.isCollapsed = true;
          document.getElementById('howToArrow').style.opacity = '1';
          function toggleArrow() {
            setTimeout(() => {
              document.getElementById('howToArrow').style.opacity = '0';
            }, 2500);
          }

          toggleArrow();
        },
      },
    ];
  }

  //#region Language translate
  loadLanguageTranslationData() {
    const controlNameList = [
      { controlName: "home" },
      { controlName: "admin" },
      { controlName: "orderManagement" },
      { controlName: "invoiceInquiry" },
      { controlName: "manageQuotes" },
      { controlName: "orderInquiry" },
      { controlName: "buildAndBuyLowercase" },
      { controlName: "selfServiceUtilities" },
      { controlName: "creditReference" },
      { controlName: "generateWarranty" },
      { controlName: "sampleRequest" },
      { controlName: "submittalPackage" },
      { controlName: "lienRelease" },
      { controlName: "thermalCalculator" },
      { controlName: "windowPricingToolLbl" },
      { controlName: "literature" },
      { controlName: "priceCatalog" },
      { controlName: "installationAndCare" },
      { controlName: "installationInstructions" },
      { controlName: "installationVideoCurtainwall" },
      { controlName: "cleaningAluminumFinishes" },
      { controlName: "installationVideoStorefront" },
      { controlName: "orderForms" },
      { controlName: "correctiveFieldRepair" },
      { controlName: "estimatingAndTakeoffGuides" },
      { controlName: "certifications" },
      { controlName: "videoTrainingLbl" },
      { controlName: "training" },
      { controlName: "customerSpecificSchool" },
      { controlName: "mechanicsSchool" },
      { controlName: "modulesSchool" },
      { controlName: "partnerPakTraining" },
      { controlName: "preInstallationSystemReview" },
      { controlName: "newsLbl" },
      { controlName: "windowPricingToolLbl" },
    ];
    const componentName = "menu";
    const response = this.languageTranslationService.getLanguageTranslationList(controlNameList, componentName);
    if (response.length > 0) {
      this.menuLblTxt = response[response.length - 1];
    }

  }


  //#endregion
}
